import axios from 'axios';
import * as firebase from 'firebase';

import { BASE_URL } from './config';

export async function loginUserFromFirebase({ email = null, password = null }){
  try {
    await firebase.auth().signInWithEmailAndPassword(email, password);
    return firebase.auth().currentUser;
  } catch (e) {
    throw e;
  }
}

export async function logoutUserFromFirebase(){
  try {
    await firebase.auth().signOut()
  } catch(e) {
    throw  e;
  }
}

export async function getUserFromFirebase(){
  try {
    return await getUser();
  } catch (e) {
    throw e;
  }
} 

function getUser(){
  return new Promise((resolve, reject) => {
    firebase.auth().onAuthStateChanged(user => {
      if (!user) return reject("Not Authorized!")
      return resolve(user);
    })
  })
}

export async function addUserToFirebase({ token = '', email = '', password = '', name = '', username = '', active = '', ...rest }){
  try {

    console.log(rest)
    //${BASE_URL}/addUser
    //https://us-central1-trimed-894e6.cloudfunctions.net/addUser
    return await axios.post(`${BASE_URL}/addUser`, { email, password, name, username, active, ...rest }, {
      headers: {
        'Authorization': token
      }
    })
  } catch (e) {
    throw e;
  }
}

export async function updateUserToFirebase({ token = '', data, username }){
  try {
    return await axios.post(`${BASE_URL}/updateUser?username=${username}`, data, {
      headers: {
        'Authorization': token
      }
    })
  } catch (e) {
    throw e;
  }
}

export async function importUsersToFirebase({ token = '', data = null }){
  try {
    //${BASE_URL}/addUser
    //http://localhost:5003/trimed-894e6/us-central1/importUsersFromCsv
    // https://us-central1-trimed-894e6.cloudfunctions.net/importUsersFromCsv
    return await axios.post(`${BASE_URL}/importUsersFromCsv`, data, {
      headers: {
        'Authorization': token,
        'Accept': 'multipart/form-data'
      }
    })
  } catch (e) {
    throw e;
  }
}

export async function updateUsersBalanceToFirebase({ token = '', data = null }){
  try {
    //${BASE_URL}/addUser
    //http://localhost:5003/trimed-894e6/us-central1/importUsersFromCsv
    // https://us-central1-trimed-894e6.cloudfunctions.net/importUsersFromCsv
    return await axios.post(`${BASE_URL}/updateUsersBalanceFromCsv`, data, {
      headers: {
        'Authorization': token,
        'Accept': 'multipart/form-data'
      }
    })
  } catch (e) {
    throw e;
  }
}

export async function getUsersDataFromFirebase({ token , limit = 10, page = 1 }){
  try {
    return await axios.get(`${BASE_URL}/getUserData?limit=${limit}&page=${page}`,{
      headers: {
        'Authorization': token
      }
    })
  } catch (e) {
    throw e;
  }
}

export async function getSingleUserFromFirebase({ token, username }){
  try {
    return await axios.get(`${BASE_URL}/getUser?username=${username}`,{
      headers: {
        'Authorization': token
      }
    })
  } catch (e) {
    throw e;
  }
}

export async function deleteUserFromFirebase({ token, username }){
  try {
    return await axios.post(`${BASE_URL}/deleteUser?username=${username}`,{},{
      headers: {
        'Authorization': token
      }
    })
  } catch (e) {
    throw e;
  }
}

export async function searchUserFromFirebase({ token, query }){
  try {
    return await axios.get(`${BASE_URL}/searchUser?search=${query}`, {
      headers: {
        'Authorization': token
      }
    })
  } catch (e) {
    throw e;
  }
}


export async function checkUserRole(id) {
  try {
    const role = await getRole(id)
    if (!['admin', 'finance'].includes(role)) {
      throw new Error('You are not allowed to login in dashboard!')
    }
    return role
  } catch (e) {
    throw e
  }
}

async function getRole(uid) {
  try {
    const roles = await getRoles();
    const role = roles.find(role => role.data[uid])
    if (!role) {
      throw new Error('You are not allowed to login in dashboard!')
    }
    return role.key
  } catch (e) {
    throw e
  }
}

function getRoles() {
  return new Promise((resolve, reject) => {
    firebase.database().ref().child('roles').once('value', snapshots => {
      if (!snapshots.val()) {
        return reject('No roles found!')
      }
      const roles = [];
      snapshots.forEach(snapshot => {
        roles.push({
          key: snapshot.key,
          data: snapshot.val()
        })
      })
      return resolve(roles);
    })
  });
}


// WEBPACK FOOTER //
// ./src/utils/userService.js